<template>
  <section>
    <v-dialog
      v-model="internalDialog"
      @click:outside="cancelar"
      @keydown.esc="cancelar"
      @keydown.enter="confirmar"
      max-width="600"
    >
      <template v-slot:default="{ isActive }">
        <v-card>
          <template v-slot:title>
            <div style="display: flex; justify-content: space-between">
              <div>
                <span>{{ options.title }}</span>
              </div>
              <div>
                <v-btn
                  icon="mdi-close"
                  size="x-small"
                  variant="tonal"
                  @click="cancelar"
                ></v-btn>
              </div>
            </div>
          </template>
          <div class="mx-5" style="display: flex; gap: 1rem">
            <v-icon size="large" :icon="options.icon"></v-icon>
            <span>{{ options.text }}</span>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :text="options.cancelButton?.text || 'Cancelar'"
              :color="options.cancelButton?.color"
              :icon="options.cancelButton?.icon"
              :size="options.cancelButton?.size"
              :variant="options.cancelButton?.variant"
              @click="cancelar"
            ></v-btn>
            <v-btn
              :text="options.confirmButton?.text || 'Confirmar'"
              :color="options.confirmButton?.color || 'primary'"
              :icon="options.confirmButton?.icon || null"
              :size="options.confirmButton?.size"
              :variant="options.confirmButton?.variant || 'flat'"
              @click="confirmar"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </section>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { ConfirmOptions } from '@/types/plugins/confirm'

interface Props {
  modelValue: boolean
  options: ConfirmOptions
}

const props = defineProps<Props>()
const internalDialog = ref(props.modelValue)

watch(
  () => props.modelValue,
  (newVal) => {
    internalDialog.value = newVal
  }
)

const cancelar = () => {
  internalDialog.value = false
  if (props.options.onCancel) props.options.onCancel()
}

const confirmar = () => {
  internalDialog.value = false
  if (props.options.onConfirm) props.options.onConfirm()
}
</script>
